{
  "cal": "Cals",
  "cancelledOrderAction": "We're sorry, but it looks like your order has been cancelled and will be refunded within the next few business days. If you’d like to place your order again you can use the button below.",
  "clickHereForDetails": "Click here for details",
  "deliveryFeeDescription": "Delivery fee varies for each restaurant based on your location and other factors.",
  "errorDialogFavoriteStoreMessage": "To set a favourite store, first sign up or log in to an account.",
  "favorite": "Favourites",
  "favoriteRemoveAllModalBody": "Removing all the items in this order will delete your favourite. Are you sure you want to delete this order?",
  "itemFavorited": "Item saved to favourites!",
  "itemFavoritedError": "Oops! There was an error with your favourite. Please try again later.",
  "loyaltyProfileEarnCrownsBody": "Get 100 Crowns for every $1 spent on eligible purchases.",
  "nameYourFavorite": "Name Your Favourite",
  "noFavoritesHeader": "Favourites",
  "noFavoritesSubheader": "Favourite an item from your cart or recents to save it as a favourite.",
  "otpFormHeadline": "Earn Crowns towards items on the menu",
  "paymentNotSupported": "Please try selecting another payment method or another nearby restaurant.",
  "removeFavorite": "Remove from Favourites?",
  "removeFavoriteConfirm": "Are you sure you want to remove this favourite?",
  "removeFavoriteOrderSucess": "Order removed from favourites.",
  "removeFavoriteSucess": "Your favourite has been removed.",
  "saveFavoriteOrderButton": "Save In Favourites",
  "saveFavoriteOrderSucess": "Order saved to favourites!",
  "saveFavoriteOrderUnsavedBody": "Do you want to continue without saving your changes in the favourite order?",
  "serviceFeeDescription": "Service Fee consists of {percent}% of your order before taxes.",
  "setRestaurantAsFavorite": "Set this restaurant as a favourite",
  "shareMyLocation": "Share my location",
  "smallCartFeeDescription": "This fee only applies to orders less than {amount}. Add items to remove the fee.",
  "storeLocatorEmptyStateFavoritesNoAuthBody": "To set a favourite location, first log in or sign up for an account.",
  "storeLocatorEmptyStateFavoritesNoAuthTitle": "Log In to Save Favourites",
  "storeLocatorEmptyStateFavoritesNoStoresBody": "Tap the heart on a store to save it as a favourite.",
  "storeLocatorEmptyStateFavoritesNoStoresTitle": "No Favourites Yet",
  "sulphurDioxide": "Sulphites",
  "unauthenticatedFavoritesHeader": "Log In to Save Favourites",
  "unauthenticatedFavoritesSubtext": "Sign up or log in to save your favourites.",
  "zipCode": "Postal Code",
  "zipCodeInvalid": "Postal Code Invalid",
  "zipCodeRequiredError": "Postal code is a required field"
}
